import BRONZE_BG from "@assets/steps/master.png";
import GradientBorder from "@core-components/gradient-border/GradientBorder";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Card, CardSection, Group, List, Text, ThemeIcon } from "@mantine/core";
import { IconCaretLeftFilled, IconCaretRightFilled } from "@tabler/icons-react";
import Coins from "../Coins";

const MasterStepCard: React.FC = () => {
  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <Card
      withBorder
      classNames={{
        root: "bg-primary-client border-master-stroke w-full flex-1 min-w-[350px] max-w-[500px]",
      }}
    >
      <Card.Section
        classNames={{
          section:
            "p-4 bg-master-background border-b-[1px] border-master-stroke text-center",
        }}
      >
        <SSWhiteText fz={20} fw={"bold"}>
          {t("stepCards.master.title")}
        </SSWhiteText>
      </Card.Section>
      <CardSection
        className={
          "before:background-image-[var(--image-url)] relative before:absolute before:top-0 before:h-full before:w-full before:bg-cover before:bg-top before:opacity-20 before:content-[''] " +
          " flex h-full flex-col items-center justify-center bg-gradient-to-b from-[#AE31AC]/20 to-[#481447]/20 p-4"
        }
        style={
          {
            "--image-url": `url('${BRONZE_BG}')`,
          } as React.CSSProperties
        }
      >
        <GradientBorder className="gradient-border-master z-10 my-12 rounded-lg">
          <Text className="w-fit text-nowrap rounded-lg bg-[#5F3A77] px-1 py-2 font-bold text-3xl text-primary-white">
            <ThemeIcon variant="transparent">
              <IconCaretRightFilled />
            </ThemeIcon>{" "}
            {t("stepCards.master.spent")}{" "}
            <ThemeIcon variant="transparent">
              <IconCaretLeftFilled />
            </ThemeIcon>
          </Text>
        </GradientBorder>
        <GradientBorder
          className="gradient-gray-to-light-white hover-scale rounded-[4px]"
          childrenClassName="p-5 !bg-primary-client text-primary-white font-bold"
        >
          {t("stepCards.master.bonus")}
          <br />
          <List className="list-disc">
            <List.Item>{t("stepCards.master.cashback")}</List.Item>
            <List.Item>{t("stepCards.master.reward")}</List.Item>
          </List>
        </GradientBorder>
        <Group className="z-50">
          <Coins size={36} />
          <Text className="py-4 font-bold text-3xl text-primary-white">
            {t("stepCards.master.badge")}
          </Text>
        </Group>
      </CardSection>
    </Card>
  );
};

export default MasterStepCard;
